
























































































































































































import {Serialize} from "cerialize"
import {Component} from 'vue-property-decorator'
import Vue from 'vue';

import MainNavigation from "../components/MainNavigation.vue";
import DeleteDialog from "../components/dialogs/DeleteDialog.vue";

import ErrorStore from "@/ts/stores/ErrorStore";
import DeleteDialogStore from "@/ts/stores/DeleteDialogStore";

import Clients from "../API/Clients";

import Client from "../ts/interfaces/Client";
import moment from "moment";
import SnackbarStore from "@/ts/stores/SnackbarStore";
import AppPackages from "@/API/AppPackages";
import Package from "@/ts/interfaces/Package";

@Component({
    components: {
        MainNavigation,
        DeleteDialog
    },
})

export default class MandateDetail extends Vue {
    valid = false;

    client: Client | null = null;
    teamId = 0;

    shortDescription = '';
    shortDescriptionRules = [
        (v: any) => v.length <= 10 || 'Kurzbezeichnung darf maximal 10 Zeichen lang sein'
    ];

    name = '';
    nameRules = [
        (v: any) => !!v || 'Firma oder Name wird benötigt'
    ];

    department = '';
    contactPerson = '';
    contactRules = [
        (v: any) => !!v || 'Ansprechpartner wird benötigt'
    ];
    functionContactPerson = '';
    phone = '';
    phoneRules = [
        (v: any) => !!v || 'Telefonnummer wird benötigt'
    ];

    mobilePhone = '';

    email = '';
    emailRules = [
        (v: any) => !!v || 'E-mail wird benötigt',
        (v: any) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Geben sie eine gültige E-mail ein'
    ];

    street = '';
    streetRules = [
        (v: any) => !!v || 'Straße wird benötigt'
    ];
    zip = '';
    zipRules = [
        (v: any) => !!v || 'Postleitzahl wird benötigt'
    ];
    city = '';
    cityRules = [
        (v: any) => !!v || 'Ort wird benötigt'
    ];
    select = '';
    items = [
        'Aktiv',
        'Inaktiv',
        'Gesperrt'
    ];

    userAccounts = 0;
    spaceSizeLimit = 50;

    officeEnabled = false;
    offersEnabled = true;
    packageId = -1;

    orderNumber = '';
    ustID = '';

    packages: Package[] = [];
    appPackage: Package | null = null;

    get displayPackages() {
        return this.packages
    }

    //Lifecylce
    mounted() {
        AppPackages.getAppPackages().then(res => {
            this.packages = res;
        });

        let mandateID = this.$route.query.id;

        Clients.getSingleClient(Number(mandateID)).then(res => {
            this.client = res;

            this.teamId = res.team_id;
            this.shortDescription = res.short_description;
            this.name = res.name;
            this.department = res.department;
            this.contactPerson = res.contact_person;
            this.functionContactPerson = res.function_contact_person;
            this.phone = res.phone;
            this.mobilePhone = res.mobile_phone;
            this.email = res.email;
            this.street = res.street;
            this.zip = res.zip;
            this.city = res.city;
            this.userAccounts = res.user_accounts;
            this.officeEnabled = res.office_enabled;
            this.offersEnabled = !res.offers_disabled;
            this.packageId = res.packet_id;

            switch (res.state) {
                case "active":
                    this.select = this.items[0];
                    break;
                case "inactive":
                    this.select = this.items[1];
                    break;
                case "locked":
                    this.select = this.items[2];
                    break;
            }

            this.orderNumber = res.order_number;
            this.ustID = res.ust_id;
        }).then(res => {
            AppPackages.getSinglePackage(this.packageId).then(res => {
                this.appPackage = res;
            })
        });

        //@ts-ignore:
        let mandate = document.getElementById("group-mandate").firstChild.firstChild.firstChild;
        let packages = document.getElementById("icon-packages");
        let news = document.getElementById("icon-news");
        let settings = document.getElementById("icon-settings");

        //@ts-ignore:
        mandate.style = "color: #81B219";
        //@ts-ignore:
        packages.style = "color: rgba(0, 0, 0, 0.54)";
        //@ts-ignore:
        settings.style = "color: rgba(0, 0, 0, 0.54)";
        //@ts-ignore:
        news.style = "color: rgba(0, 0, 0, 0.54)";
    };

    //Methods/Functions
    openDeleteDialog() {
        DeleteDialogStore.show()
    }

    saveItem() {
        this.getApiStatus();

        ((this.$refs.form as HTMLFormElement).validate());
        if (this.$data.valid === true) {
            let client = new Client(this.teamId,
                this.name,
                this.shortDescription,
                this.department,
                this.contactPerson,
                this.functionContactPerson,
                this.phone,
                this.mobilePhone,
                this.email,
                this.street,
                this.zip,
                this.city,
                this.select,
                this.orderNumber,
                this.ustID,
                0,
                "",
                Number(this.spaceSizeLimit),
                false,
                moment().toString(),
                this.userAccounts,
                [],
                this.officeEnabled,
                this.offersEnabled,
                this.packageId
            );

            let serializedClient = Serialize(client);

            Clients.updateClient(this.teamId, serializedClient).then(res => {
                this.$router.push("/mandates");
                SnackbarStore.show("Mandant erfolgreich editiert")
            })
        }
    }

    getApiStatus() {
        switch (this.select) {
            case this.items[0]:
                this.select = "active";
                break;
            case this.items[1]:
                this.select = "inactive";
                break;
            case this.items[2]:
                this.select = "locked";
                break;
        }
    }

    getPackage(appPackage: Package) {
        this.appPackage = appPackage;
        this.packageId = appPackage.id;
    }

    deleteClient() {
        Clients.deleteClient(this.teamId).then(res => {
            this.$router.push("/mandates");
            SnackbarStore.showWithTimeout(
                "Mandant erfolgreich gelöscht, Änderungen können erst nach einigen Minuten sichtbar werden. " +
                "Zum Aktualisieren betätigen Sie bitte den zugehörigen Button.",
                4000
            )
        }).catch(err => {
            if (err.message && err.message.description) {
                ErrorStore.showError(err.message.description)
            } else {
                ErrorStore.showError("Serverfehler beim Löschen")
            }
        });
        DeleteDialogStore.dismiss()
    }
}
